import React from "react";
import PropTypes from "prop-types";
import { Carousel } from "react-responsive-carousel";
import { Segmant } from "../../components";

const NhGallery = ({
  imageData,
  toggle,
  street,
  openpopup,
  selectedItem,
  nhid,
  page,
}) => {
  let icons = process.env.NEXT_PUBLIC_CDN_ID + "static/images/icon.jpg";
  street ? imageData.push(icons) : null;

  let length = imageData.length;
  async function getMeta(url, id) {
    // Only run on client side
    if (typeof window === 'undefined') return;

    let w;
    let h;
    let img = new Image();
    img.src = url;
    img.onload = function () {
      w = this.width;
      h = this.height;
      if (
        document.getElementById(id) &&
        document.getElementById(id) != undefined
      ) {
        if (h > w || h === w) {
          document.getElementById(id).style.width = "auto";
          document.getElementById(id).style.height = "100%";
        } else {
          document.getElementById(id).style.width = "100%";
          document.getElementById(id).style.height = "100%";
        }
      }
    };
  }
  return (
    <div>
      <Segmant className="pr-0">
        {street ? (
          <Carousel
            showIndicators={false}
            infiniteloop={true}
            autoPlay={false}
            interval={2000}
            onClickThumb={(e) => toggle(e, length)}
          >
            {imageData &&
              imageData.map((image, index) => {
                // if (image.imageurl && image.imageurl != "") {
                //   // let imgid = `imgdata${index}`;
                //   //if(nhid === "b4abea99-5c11-4961-973d-020d1526755f"){
                //   // let end = getMeta(image.imageurl, imgid);
                // }
                //}
                return (
                  <div key={index}>
                    <img
                      src={image.imageurl + "?cacheblock=true"}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/defaultadd.jpg";
                      }}
                      id={`imgdatahome${index}`}
                      crossOrigin="anonymous"
                      alt={
                        page && page === "city"
                          ? `City-${index + 1}`
                          : `Neighborhood-${index + 1}`
                      }
                      title="Neighborhood"
                      loading="lazy"
                    />
                  </div>
                );
              })}
          </Carousel>
        ) : (
          <Carousel
            showIndicators={false}
            infiniteloop={true}
            autoPlay={false}
            interval={2000}
            onClickItem={(e) => openpopup(e, length)}
            selectedItem={selectedItem}
          >
            {imageData &&
              imageData.map((image, index) => {
                // if (image.imageurl && image.imageurl != "") {
                //   // let imgid = `imgdata${index}`;
                //   // if(nhid === "b4abea99-5c11-4961-973d-020d1526755f"){
                //   // let end = getMeta(image.imageurl, imgid);
                //   // }
                // }
                return (
                  <div key={index}>
                    <img
                      src={image.imageurl + "?cacheblock=true"}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/defaultadd.jpg";
                      }}
                      id={`imgdata${index}`}
                      crossOrigin="anonymous"
                      alt={
                        page && page === "city"
                          ? `City-${index + 1}`
                          : `Neighborhood-${index + 1}`
                      }
                      title="Neighborhood"
                      loading="lazy"
                    />
                    {/* {image.username && (
                      <p className="legend">
                        Photo Credit: {image.username}
                        {image.userrole &&
                          image.userrole !== "webuser" &&
                          ", Agent"}
                      </p>
                    )} */}
                  </div>
                );
              })}
          </Carousel>
        )}
      </Segmant>
    </div>
  );
};

NhGallery.propTypes = {
  imageData: PropTypes.array.isRequired,
  button: PropTypes.bool,
};
export default NhGallery;
